// import { BrowserRouter, Route, Routes } from "react-router-dom";
// import MainLayout from "./components/layout/MainLayout";
// import { routes } from "./routes";
// import LoginPage from "./loginPage/LoginPage";
// import { Provider } from "react-redux";
// import { useEffect } from "react";
// import { migrateToEncryptedStorage } from "./utils/migrateData";

// function App() {
//   useEffect(() => {
//     // Migrate existing data to encrypted format
//     migrateToEncryptedStorage();
//   }, []);

//   return (
//     <BrowserRouter>
//         <Routes>
//           <Route path="/login" element={<LoginPage />}></Route>
//           <Route path="/" element={<MainLayout />}>
//             {routes}
//           </Route>
//         </Routes>
//     </BrowserRouter>
//   );
// }

// export default App;




import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import MainLayout from "./components/layout/MainLayout";
import { routes } from "./routes";
import LoginPage from "./loginPage/LoginPage";
import { useEffect } from "react";
import { migrateToEncryptedStorage } from "./utils/migrateData";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  useEffect(() => {
    migrateToEncryptedStorage();
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        {/* पब्लिक लॉगिन पेज */}
        <Route path="/login" element={<LoginPage />} />

        {/* प्रोटेक्टेड रूट्स: बिना टोकन के MainLayout और अंदर के पेज एक्सेस नहीं होंगे */}
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<MainLayout />}>
            {routes}
          </Route>
        </Route>

        {/* अगर कोई रूट मैच न हो तो सीधे लॉगिन पर भेजें */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;